import type { FC, ReactNode } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'
import type { Image } from '@/features/photoset/types'
import { useTranslation } from '@/translations/i18n'

interface GalleryModalHeaderProps {
	currentImage: Pick<Image, 'id' | 'name'>
	onClose: () => void
	kickerTitle?: string
	iconTitle?: ReactNode
	subtitle?: string
	imagesCount?: number
	endSlot?: ReactNode
}

export const GalleryModalHeader: FC<GalleryModalHeaderProps> = ({
	currentImage,
	onClose,
	kickerTitle,
	iconTitle,
	subtitle,
	imagesCount,
	endSlot
}) => {
	const { t } = useTranslation()

	return (
		<div className='flex flex-col items-stretch gap-4'>
			<ButtonLegacy
				onClick={onClose}
				shape='square'
				size='sm'
				type='button'
				variant='tertiary'
			>
				<XCloseIcon />
			</ButtonLegacy>
			<div className='flex items-center justify-between gap-1'>
				{currentImage && (
					<hgroup>
						{kickerTitle && (
							<p className='text-base text-neutral-900'>
								{kickerTitle}
							</p>
						)}
						<div className='flex items-center gap-1'>
							{iconTitle}
							<h1 className='font-medium text-lg text-neutral-900'>
								{currentImage.name}
							</h1>
						</div>
						{subtitle && (
							<h2 className='text-neutral-700 text-sm'>
								{subtitle}
							</h2>
						)}
						{imagesCount && (
							<h4>
								{t('common:x_images', { count: imagesCount })}
							</h4>
						)}
					</hgroup>
				)}

				{endSlot}
			</div>
		</div>
	)
}

GalleryModalHeader.displayName = 'GalleryModalHeader'
